!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.cognite = t() : e.cognite = t();
}(window, function () {
  return function (e) {
    var t = {};

    function o(n) {
      if (t[n]) return t[n].exports;
      var a = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(a.exports, a, a.exports, o), a.l = !0, a.exports;
    }

    return o.m = e, o.c = t, o.d = function (e, t, n) {
      o.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, o.t = function (e, t) {
      if (1 & t && (e = o(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (o.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var a in e) {
        o.d(n, a, function (t) {
          return e[t];
        }.bind(null, a));
      }
      return n;
    }, o.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return o.d(t, "a", t), t;
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.p = "", o(o.s = 2);
  }([function (e, t) {
    e.exports = require("three");
  }, function (e, t, o) {
    "use strict";

    var _n,
        a = o(0),
        r = {
      16: "shift",
      17: "ctrl",
      18: "alt",
      27: "escape",
      32: "space",
      37: "left",
      38: "up",
      39: "right",
      40: "down",
      65: "a",
      68: "d",
      69: "e",
      81: "q",
      83: "s",
      87: "w"
    },
        i = function () {
      return function () {
        var e = this;
        this.keys = {}, this.isPressed = function (t) {
          return e.keys[t] >= 1;
        }, this.comsumePressed = function (t) {
          var o = 2 === e.keys[t];
          return o && (e.keys[t] = 1), o;
        }, Object.keys(r).forEach(function (t) {
          e.keys[r[t]] = 0;
        }), window.addEventListener("keydown", function (t) {
          t.metaKey || t.altKey || t.ctrlKey || t.keyCode in r && 0 === e.keys[r[t.keyCode]] && (e.keys[r[t.keyCode]] = 2);
        }), window.addEventListener("keyup", function (t) {
          t.keyCode in r && (e.keys[r[t.keyCode]] = 0);
        }), window.addEventListener("blur", function () {
          Object.keys(e.keys).forEach(function (t) {
            e.keys[t] = 0;
          });
        });
      };
    }(),
        s = (_n = function n(e, t) {
      return (_n = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      })(e, t);
    }, function (e, t) {
      function o() {
        this.constructor = e;
      }

      _n(e, t), e.prototype = null === t ? Object.create(t) : (o.prototype = t.prototype, new o());
    }),
        c = -1 !== navigator.userAgent.toLowerCase().indexOf("firefox");

    function u(e, t, o) {
      return new a.Vector2(t - e.offsetLeft, o - e.offsetTop);
    }

    function d(e, t) {
      if (2 !== t.length) throw new Error("getPinchInfo only works if touches.length === 2");
      var o = [t[0], t[1]].map(function (t) {
        var o = t.clientX,
            n = t.clientY;
        return u(e, o, n);
      });
      return {
        center: o[0].clone().add(o[1]).multiplyScalar(.5),
        distance: o[0].distanceTo(o[1]),
        offsets: o
      };
    }

    var l = Math.PI / 360,
        m = 10 * l,
        p = function (e) {
      function t(t, o) {
        var n = e.call(this) || this;
        return n.enabled = !0, n.enableDamping = !0, n.dampingFactor = .2, n.dynamicTarget = !0, n.minDistance = 1, n.maxDistance = 1 / 0, n.dollyFactor = .98, n.minPolarAngle = 0, n.maxPolarAngle = Math.PI, n.minAzimuthAngle = -1 / 0, n.maxAzimuthAngle = 1 / 0, n.panDollyMinDistanceFactor = 10, n.firstPersonRotationFactor = .4, n.pointerRotationSpeedAzimuth = l, n.pointerRotationSpeedPolar = l, n.enableKeyboardNavigation = !0, n.keyboardRotationSpeedAzimuth = m, n.keyboardRotationSpeedPolar = m, n.mouseFirstPersonRotationSpeed = 2 * l, n.keyboardDollySpeed = 2, n.keyboardPanSpeed = 10, n.keyboardSpeedFactor = 3, n.pinchEpsilon = 2, n.pinchPanSpeed = 1, n.EPSILON = .001, n.minZoom = 0, n.maxZoom = 1 / 0, n.orthographicCameraDollyFactor = .3, n.temporarilyDisableDamping = !1, n.firstPersonMode = !1, n.reusableVector3 = new a.Vector3(), n._accumulatedMouseMove = new a.Vector2(), n.target = new a.Vector3(), n.targetEnd = new a.Vector3(), n.spherical = new a.Spherical(), n.sphericalEnd = new a.Spherical(), n.deltaTarget = new a.Vector3(), n.keyboard = new i(), n.offsetVector = new a.Vector3(), n.panVector = new a.Vector3(), n.raycaster = new a.Raycaster(), n.targetFPS = 30, n.targetFPSOverActualFPS = 1, n.update = function (e) {
          var t = n,
              o = t.camera,
              a = t.target,
              r = t.targetEnd,
              i = t.spherical,
              s = t.sphericalEnd,
              c = t.deltaTarget,
              u = t.handleKeyboard,
              d = t.enableDamping,
              l = t.dampingFactor,
              m = t.EPSILON,
              p = t.targetFPS;
          if (!t.enabled) return !1;
          var h = Math.min(1 / e, p);
          n.targetFPSOverActualFPS = p / h, u(), n._accumulatedMouseMove.lengthSq() > 0 && (n.rotate(n._accumulatedMouseMove.x, n._accumulatedMouseMove.y), n._accumulatedMouseMove.set(0, 0)), s.theta = Math.sign(s.theta) * Math.min(Math.abs(s.theta), 2 * Math.PI);
          var f = s.theta - i.theta;
          Math.abs(f) > Math.PI && (f -= 2 * Math.PI * Math.sign(f));
          var v = s.phi - i.phi,
              y = s.radius - i.radius;
          c.subVectors(r, a);
          var g = !1,
              M = d && !n.temporarilyDisableDamping ? Math.min(l * n.targetFPSOverActualFPS, 1) : 1;
          return n.temporarilyDisableDamping = !1, Math.abs(f) > m || Math.abs(v) > m || Math.abs(y) > m || Math.abs(c.x) > m || Math.abs(c.y) > m || Math.abs(c.z) > m ? (i.set(i.radius + y * M, i.phi + v * M, i.theta + f * M), i.theta = i.theta % (2 * Math.PI), a.add(c.multiplyScalar(M)), g = !0) : (i.copy(s), a.copy(r)), i.makeSafe(), o.position.setFromSpherical(i).add(a), o.lookAt(a), g && n.triggerCameraChangeEvent(), g;
        }, n.getState = function () {
          var e = n,
              t = e.target,
              o = e.camera;
          return {
            target: t.clone(),
            position: o.position.clone()
          };
        }, n.setState = function (e, t) {
          var o = e.clone().sub(t);
          n.targetEnd.copy(t), n.sphericalEnd.setFromVector3(o), n.target.copy(n.targetEnd), n.spherical.copy(n.sphericalEnd), n.update(1e3 / n.targetFPS), n.triggerCameraChangeEvent();
        }, n.triggerCameraChangeEvent = function () {
          var e = n,
              t = e.camera,
              o = e.target;
          n.dispatchEvent({
            type: "cameraChange",
            camera: {
              position: t.position,
              target: o
            }
          });
        }, n.onMouseDown = function (e) {
          if (n.enabled) switch (e.preventDefault(), e.button) {
            case a.MOUSE.LEFT:
              n.startMouseRotation(e);
              break;

            case a.MOUSE.RIGHT:
              n.startMousePan(e);
          }
        }, n.onMouseUp = function (e) {
          n._accumulatedMouseMove.set(0, 0);
        }, n.onMouseWheel = function (e) {
          if (n.enabled) {
            e.preventDefault();
            var t = 0;
            if (e.wheelDelta) t = -e.wheelDelta / 40;else if (e.detail) t = e.detail;else if (e.deltaY) {
              var o = c ? 1 : 40;
              t = e.deltaY / o;
            }
            var a = n.domElement,
                r = e.offsetX,
                i = e.offsetY;
            r = r / a.clientWidth * 2 - 1, i = i / a.clientHeight * -2 + 1;
            var s = t < 0,
                u = n.camera.isPerspectiveCamera ? n.getDollyDeltaDistance(s, Math.abs(t)) : Math.sign(t) * n.orthographicCameraDollyFactor;
            n.dolly(r, i, u);
          }
        }, n.onTouchStart = function (e) {
          if (n.enabled) switch (e.preventDefault(), e.touches.length) {
            case 1:
              n.startTouchRotation(e);
              break;

            case 2:
              n.startTouchPinch(e);
          }
        }, n.onContextMenu = function (e) {
          n.enabled && e.preventDefault();
        }, n.rotate = function (e, t) {
          if (0 !== e || 0 !== t) {
            var o = (n.firstPersonMode ? n.mouseFirstPersonRotationSpeed : n.pointerRotationSpeedAzimuth) * e,
                a = (n.firstPersonMode ? n.mouseFirstPersonRotationSpeed : n.pointerRotationSpeedPolar) * t;
            n.firstPersonMode ? (n.temporarilyDisableDamping = !0, n.rotateFirstPersonMode(o, a)) : n.rotateSpherical(o, a);
          }
        }, n.startMouseRotation = function (e) {
          n.domElement;

          var t = new a.Vector2(e.offsetX, e.offsetY),
              o = function o(e) {
            var o = new a.Vector2(e.offsetX, e.offsetY),
                r = t.clone().sub(o);
            n._accumulatedMouseMove.add(r), t = o;
          },
              r = function r() {
            window.removeEventListener("mousemove", o), window.removeEventListener("mouseup", r);
          };

          window.addEventListener("mousemove", o, {
            passive: !1
          }), window.addEventListener("mouseup", r, {
            passive: !1
          });
        }, n.startMousePan = function (e) {
          n.domElement;

          var t = new a.Vector2(e.offsetX, e.offsetY),
              o = function o(e) {
            var o = new a.Vector2(e.offsetX, e.offsetY),
                r = o.x - t.x,
                i = o.y - t.y;
            t = o, n.pan(r, i);
          },
              r = function r() {
            window.removeEventListener("mousemove", o), window.removeEventListener("mouseup", r);
          };

          window.addEventListener("mousemove", o, {
            passive: !1
          }), window.addEventListener("mouseup", r, {
            passive: !1
          });
        }, n.startTouchRotation = function (e) {
          var t = n.domElement,
              o = u(t, e.touches[0].clientX, e.touches[0].clientY),
              a = function a(e) {
            if (1 === e.touches.length) {
              var a = u(t, e.touches[0].clientX, e.touches[0].clientY);
              n.rotate(o.x - a.x, o.y - a.y), o = a;
            }
          },
              r = function r(e) {
            1 !== e.touches.length && s();
          },
              i = function i() {
            s();
          },
              s = function s() {
            document.removeEventListener("touchstart", r), document.removeEventListener("touchmove", a), document.removeEventListener("touchend", i);
          };

          document.addEventListener("touchstart", r), document.addEventListener("touchmove", a, {
            passive: !1
          }), document.addEventListener("touchend", i, {
            passive: !1
          });
        }, n.startTouchPinch = function (e) {
          var t = n.domElement,
              o = d(t, e.touches),
              a = d(t, e.touches),
              r = n.spherical.radius,
              i = function i(e) {
            if (2 === e.touches.length) {
              var i = d(t, e.touches),
                  s = a.distance / i.distance;
              n.sphericalEnd.radius = Math.max(s * r, n.minDistance / 5);
              var c = i.center.clone().sub(o.center);
              c.length() > n.pinchEpsilon && (c.multiplyScalar(n.pinchPanSpeed), n.pan(c.x, c.y)), o = i;
            }
          },
              s = function s(e) {
            2 !== e.touches.length && u();
          },
              c = function c() {
            u();
          },
              u = function u() {
            document.removeEventListener("touchstart", s), document.removeEventListener("touchmove", i), document.removeEventListener("touchend", c);
          };

          document.addEventListener("touchstart", s), document.addEventListener("touchmove", i), document.addEventListener("touchend", c);
        }, n.handleKeyboard = function () {
          if (n.enabled && n.enableKeyboardNavigation) {
            var e = n,
                t = e.keyboard,
                o = e.keyboardDollySpeed,
                a = e.keyboardPanSpeed,
                r = e.keyboardSpeedFactor,
                i = n.keyboardRotationSpeedAzimuth * (Number(t.isPressed("left")) - Number(t.isPressed("right"))),
                s = n.keyboardRotationSpeedPolar * (Number(t.isPressed("up")) - Number(t.isPressed("down")));

            if (0 !== i || 0 !== s) {
              var c = n.sphericalEnd,
                  u = c.phi;
              c.phi += s, c.makeSafe(), s = c.phi - u, c.phi = u, n.rotateFirstPersonMode(i, s);
            }

            n.firstPersonMode = !1;
            var d = t.isPressed("shift") ? r : 1,
                l = !!t.isPressed("w") || !t.isPressed("s") && void 0;
            void 0 !== l && (n.dolly(0, 0, n.getDollyDeltaDistance(l, o * d)), n.firstPersonMode = !0);
            var m = Number(t.isPressed("a")) - Number(t.isPressed("d")),
                p = Number(t.isPressed("e")) - Number(t.isPressed("q"));
            0 === m && 0 === p || (n.pan(d * a * m, d * a * p), n.firstPersonMode = !0);
          }
        }, n.rotateSpherical = function (e, t) {
          var o = n.sphericalEnd,
              r = a.Math.clamp(o.theta + e, n.minAzimuthAngle, n.maxAzimuthAngle),
              i = a.Math.clamp(o.phi + t, n.minPolarAngle, n.maxPolarAngle);
          o.theta = r, o.phi = i, o.makeSafe();
        }, n.rotateFirstPersonMode = function (e, t) {
          var o = n,
              a = o.firstPersonRotationFactor,
              r = o.reusableCamera,
              i = o.reusableVector3,
              s = o.sphericalEnd,
              c = o.targetEnd;
          r.position.setFromSpherical(s).add(c), r.lookAt(c), r.rotateX(a * t), r.rotateY(a * e);
          var u = c.distanceTo(r.position);
          r.getWorldDirection(i), c.addVectors(r.position, i.multiplyScalar(u)), s.setFromVector3(i.subVectors(r.position, c)), s.makeSafe();
        }, n.pan = function (e, t) {
          var o = n,
              a = o.domElement,
              r = o.camera,
              i = o.offsetVector,
              s = o.target;
          i.copy(r.position).sub(s);
          var c = i.length();
          c = Math.max(c, n.panDollyMinDistanceFactor * n.minDistance), r.isPerspectiveCamera && (c *= Math.tan(r.fov / 2 * Math.PI / 180)), n.panLeft(2 * e * c / a.clientHeight), n.panUp(2 * t * c / a.clientHeight);
        }, n.dollyOrthographicCamera = function (e, t, o) {
          var r = n.camera;
          r.zoom *= 1 - o, r.zoom = a.Math.clamp(r.zoom, n.minZoom, n.maxZoom), r.updateProjectionMatrix();
        }, n.dollyPerspectiveCamera = function (e, t, o) {
          var r = n,
              i = r.dynamicTarget,
              s = r.minDistance,
              c = r.raycaster,
              u = r.reusableVector3,
              d = r.sphericalEnd,
              l = r.targetEnd,
              m = r.camera,
              p = r.reusableCamera,
              h = Math.tan(a.Math.degToRad(90 - .5 * m.fov)),
              f = Math.sqrt(h * h + e * e + t * t) / h,
              v = u.setFromSpherical(d).length();
          p.copy(m), p.position.setFromSpherical(d).add(l), p.lookAt(l), c.setFromCamera({
            x: e,
            y: t
          }, p);
          var y = u,
              g = v + o;
          g < s && (g = s, i ? (p.getWorldDirection(y), l.add(y.normalize().multiplyScalar(Math.abs(o)))) : o = v - g);
          var M = -o * f;
          d.radius = g, p.getWorldDirection(y), y.normalize().multiplyScalar(o);
          var b = c.ray.direction.normalize().multiplyScalar(M).add(y);
          l.add(b);
        }, n.dolly = function (e, t, o) {
          var a = n.camera;
          a.isOrthographicCamera ? n.dollyOrthographicCamera(e, t, o) : a.isPerspectiveCamera && n.dollyPerspectiveCamera(e, t, o);
        }, n.getDollyDeltaDistance = function (e, t) {
          void 0 === t && (t = 1);
          var o = n,
              a = o.sphericalEnd,
              r = o.dollyFactor,
              i = Math.pow(r, t),
              s = e ? i : 1 / i;
          return Math.max(a.radius, n.panDollyMinDistanceFactor * n.minDistance) * (s - 1);
        }, n.panLeft = function (e) {
          var t = n,
              o = t.camera,
              a = t.targetEnd,
              r = t.panVector;
          r.setFromMatrixColumn(o.matrix, 0), r.multiplyScalar(-e), a.add(r);
        }, n.panUp = function (e) {
          var t = n,
              o = t.camera,
              a = t.targetEnd,
              r = t.panVector;
          r.setFromMatrixColumn(o.matrix, 1), r.multiplyScalar(e), a.add(r);
        }, n.camera = t, n.reusableCamera = t.clone(), n.domElement = o, n.spherical.setFromVector3(t.position), n.sphericalEnd.copy(n.spherical), o.addEventListener("mousedown", n.onMouseDown), o.addEventListener("touchstart", n.onTouchStart), o.addEventListener("wheel", n.onMouseWheel), o.addEventListener("contextmenu", n.onContextMenu), window.addEventListener("mouseup", n.onMouseUp), n.dispose = function () {
          o.removeEventListener("mousedown", n.onMouseDown), o.removeEventListener("wheel", n.onMouseWheel), o.removeEventListener("touchstart", n.onTouchStart), o.removeEventListener("contextmenu", n.onContextMenu), window.removeEventListener("mouseup", n.onMouseUp);
        }, n;
      }

      return s(t, e), t;
    }(a.EventDispatcher);

    t.a = p;
  }, function (e, t, o) {
    "use strict";

    o.r(t);
    var n = o(1);
    o.d(t, "default", function () {
      return n.a;
    });
  }]);
});